<!-- Grid Highlight Wrapper -->

<!-- A11Y -->
<span hSrOnlyNoSnippet [attr.role]="'heading'" aria-level="3">
    {{ highlightedFilterGroups[0]?.name }}
    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
    <span i18n="@@hermes-global-translations.filter"> filter </span>
</span>

<!-- Highlight items Template -->
<div [ngClass]="this.enableNewGridHighlight() ? 'new-grid-highlight' : 'grid-highlight'">
    <h-carousel
        #carousel
        [isRewindEnabled]="!this.enableNewGridHighlight()"
        [slidesPerView]="this.enableNewGridHighlight() ? 2.5 : 2"
        [slidesPerGroup]="2"
        [a11yOptions]="carouselA11yOptions"
        [isMobile]="isMobile"
        [lazyLoadingOptions]="lazyLoadingOptions"
        [spaceBetween]="this.enableNewGridHighlight() ? 4 : isMobile ? 13 : 10"
        [controlsInset]="carouselControlsInset"
        [isControlsDisplayed]="highlightedFilters.length > nbSliderVisibles && !isMobile"
        [breakpointsConfiguration]="breakpontsConfiguration"
        [isDotsFocusable]="false"
        [centerInsufficientSlides]="shouldCenterInsufficientSlides"
        (slidersPerViewChangeByBreakpoint)="onSlidersPerViewChangeByBreakpoint($event)">
        @for (highlightedItem of highlightedFilters; track trackByHighlightedItems(idx, highlightedItem); let idx =
        $index) {

        <h-grid-highlight-item
            [enableNewGridHighlight]="enableNewGridHighlight()"
            [highlightItemIndex]="idx"
            [highlightedItemFilter]="highlightedItem"
            [highlightedItemFilterGroup]="highlightedFilterGroups[0]"
            (onFocus)="isMobile ? handleFocusItem(idx) : null"
            *hSlide></h-grid-highlight-item>

        }
    </h-carousel>
</div>
@if (!enableNewGridHighlight()) {
<hr class="line-separator" />
}
<!-- END Grid Highlight Wrapper -->
